/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Past_WeekInputs */

const en_past_week = /** @type {(inputs: Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Week`)
};

const fr_past_week = /** @type {(inputs: Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine passée`)
};

const de_past_week = /** @type {(inputs: Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Woche`)
};

const it_past_week = /** @type {(inputs: Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimana scorsa`)
};

const ru_past_week = /** @type {(inputs: Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошедшая неделя`)
};

const es_past_week = /** @type {(inputs: Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La semana pasada`)
};

const zh_cn2_past_week = /** @type {(inputs: Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过去一周`)
};

const ja_past_week = /** @type {(inputs: Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先週`)
};

const hi_past_week = /** @type {(inputs: Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले सप्ताह`)
};

const pt_pt2_past_week = /** @type {(inputs: Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana passada`)
};

/**
* | output |
* | --- |
* | "Past Week" |
*
* @param {Past_WeekInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const past_week = /** @type {((inputs?: Past_WeekInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Past_WeekInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_past_week(inputs)
	if (locale === "de") return de_past_week(inputs)
	if (locale === "it") return it_past_week(inputs)
	if (locale === "ru") return ru_past_week(inputs)
	if (locale === "es") return es_past_week(inputs)
	if (locale === "zh-CN") return zh_cn2_past_week(inputs)
	if (locale === "ja") return ja_past_week(inputs)
	if (locale === "hi") return hi_past_week(inputs)
	if (locale === "pt-PT") return pt_pt2_past_week(inputs)
	return en_past_week(inputs)
});